<template>
  <div class="reupload-paper-online">
    <visa-dialog
      :show="show"
      :widthClass="'width757'"
      titleInfo="在线上传资料"
      @visibleSync="modalVisibleSync">

      <!-- 资料数组 -->
      <div class="imgs-list">

        <div class="upload-item-box" v-for="(upload, index) in uploadList" :key="upload.id">
          <upload-item
            :pdf="true"
            :file-name="upload.filename"
            :img-url="upload.url"
            :upload="upload"
            :is-multi="true"
            @uploadFile="(file, id) => uploadMultiPage(file, id, index)"
            @deleteFile="() => deleteMultiPageItem(index)"
            @reviewImage="reviewImage">
          </upload-item>
        </div>

      </div>

      <!-- 底部按钮 -->
      <div class="footer-box">
        <div class="mask-box" v-if="this.materialList.length >= 6"></div>
        <el-button class="submit-btn" :loading="submitLoading" @click="submitPaperOnlineMaterial">提交</el-button>
      </div>

    </visa-dialog>
  </div>
</template>

<script>
import User from '@/libs/user';
import sensorsdata from 'sa-sdk-javascript';
import visaDialog from '../../common/modals/visa-dialog/visa-dialog';
import uploadItem from '../../upload/upload-item';
import utils from '../../../libs/utils';
import Http from '../../../libs/http';
import uploadFileService from '../../../services/upload-file-service';

export default {
  props: {
    materialList: {
      type: Array,
      default: [],
    },
    applicant: {
      type: Object,
      default: {},
    },
    showPaperOnline: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
      default: {},
    },
  },
  components: {
    visaDialog,
    uploadItem,
  },
  data() {
    return {
      submitLoading: false,
      User,
    };
  },
  computed: {
    uploadList() {
      return this.materialList.concat([{}]);
    },
    show: {
      get() {
        return this.showPaperOnline;
      },
      set(newValue) {
        this.$emit('visibleSync', newValue);
      },
    },
  },
  methods: {
    modalVisibleSync(val) {
      this.show = val;
    },

    // 上传资料函数
    doUploadMultiPage(files, id, index) {

      // 转为真正的数组
      const filesArr = Array.from(files);

      // 在这里可以根据url判断是不是文件替换
      const isReplaceFile = !!id;
      const promiseStack = filesArr.map(file => uploadFileService.uploadFile(file, false, { noKey: true }).then((res) => {

        const dowloadName = file.name;

        let url;
        const params = {
          filename: dowloadName,
          key: res,
        };
        if (isReplaceFile) { // 修改
          url = '/applicant_paper_online_update';
          params.id = id;
          this.$set(this.materialList[index], 'loading', true);
        } else { // 添加
          url = '/applicant_paper_online_add';
          params.order_applicant_id = this.applicant.order_applicant_id;
        }
        return Http.post(url, params);

      }).catch((e) => {
        if (e) console.log(e);
      }));
      return Promise.all(promiseStack);
    },

    // 上传资料
    uploadMultiPage(files, id, index) {
      // 在这里可以根据url判断是不是文件替换
      const isReplaceFile = !!id;

      // 转为真正的数组
      const filesArr = Array.from(files);
      const MAX_UPLOAD_FILES = 50;
      if (!isReplaceFile && this.materialList.length + filesArr.length > MAX_UPLOAD_FILES) {
        return utils.msg.error('最多上传50个文件');
      }

      this.doUploadMultiPage(files, id, index)
        .then((imgUrls) => {

          // 添加
          if (!isReplaceFile) {

            imgUrls.map((img, imgIndex) => {
              const dowloadName = filesArr[imgIndex] && filesArr[imgIndex].name;
              img.filename = dowloadName;
              return img;
            }).forEach(item => this.materialList.push(item));

          } else {
            // 替换

            this.materialList.forEach((item) => {
              if (item.id === id) {
                item.url = imgUrls.length ? imgUrls[0].url : '';
                this.$set(item, 'loading', false);
              }
            });
          }
        })
        .catch((e) => {
          if (e) console.log(e);
          this.$set(this.materialList[index], 'loading', false);
        });
    },

    // 删除资料的一项
    deleteMultiPageItem(index) {
      const MIN_UPLOAD_FILES = 1;
      if (this.applicant.paper_online_status && this.materialList.length === MIN_UPLOAD_FILES) {
        return utils.msg.error('最后一项资料无法删除，请重新上传');
      }

      const item = this.materialList[index];
      let delete_tips;
      if (item.url && item.url.indexOf('.pdf') > -1) {
        delete_tips = '文件';
      } else {
        delete_tips = '图片';
      }

      utils.msgbox.confirm(`确定要删除该${delete_tips}吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        Http.post('/applicant_paper_online_delete', {
          id: item ? item.id : 0,
        }).then(() => {
          this.materialList.splice(index, 1);
          utils.msg.success('删除成功!');
        }).catch((e) => {
          if (e) console.log(e);
        });
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 预览图片
    reviewImage(imageSrc) {
      this.$emit('reviewImage', imageSrc);
    },

    // 提交在线上传资料
    submitPaperOnlineMaterial() {
      if (!this.materialList.length) {
        return utils.msg.error('尚未上传补充电子资料');
      }

      const handleSubmit = () => {
        this.submitLoading = true;
        Http.post('/applicant_paper_online_submit', {
          order_applicant_id: this.applicant.order_applicant_id,
        }).then(() => {
          this.show = false;
          this.submitLoading = false;
          utils.msg.success('提交成功!');
          this.$emit('paperyOnlineSubmited');
        }).catch((e) => {
          if (e) console.log(e);
          this.submitLoading = false;
          utils.msg.error('提交失败!');
        });
      };

      if (!this.applicant.paper_online_status) {

        this.$confirm('确定提交资料？提交后将无法修改为线下邮寄资料', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          handleSubmit();
          const {
            product_name, country, visa_product_id, visa_type, user_order_id,
          } = this.order;
          const { peer_account_id } = this.User;
          // 神策埋点
          sensorsdata.track('AddPaperInfo', {
            peer_account_id,
            online_offline: '在线上传',
            country,
            visa_product_id,
            platform_type: 'PC',
            visa_type,
            product_name,
            user_order_id,
          });
        }).catch((e) => {
          if (e) console.log(e);
        });
      } else {
        handleSubmit();
      }
    },
  },
};
</script>

<style lang="less">
.reupload-paper-online {
  .imgs-list{
    max-height: 410px;
    padding: 0px 10px 10px 40px;
    display: flex;
    flex-wrap: wrap;
    overflow-y: auto;
    .upload-item-box{
      margin-top: 30px;
      margin-right: 30px;
      .upload-item{
        width: 200px;
        height: 132px;
      }
    }
  }
  .footer-box{
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .submit-btn{
      width: 200px;
      height: 40px;
      background-color: #5e9be1;
      border-radius: 4px;
      color: #ffffff;
      font-size: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      border: none;
    }
    .mask-box{
      width: 100%;
      height: 40px;
      position: absolute;
      top: -40px;
      background: linear-gradient(rgba(0,0,0,0),rgba(255,255,255,1));;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/reupload/reupload-paper-online/reupload-paper-online-modal.vue